"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AutoflowResourceLog", {
    enumerable: true,
    get: function() {
        return AutoflowResourceLog;
    }
});
const _zod = require("zod");
const _baseresourcelog = require("../base-resource-log");
const AutoflowChangeType = _zod.z.union([
    _zod.z.literal("validate"),
    _zod.z.literal("test"),
    _zod.z.literal("execute")
]);
const AutoflowResourceLog = _baseresourcelog.BaseResourceLog.extend({
    resource_type: _zod.z.literal("autoflow"),
    change_type: _baseresourcelog.BaseResourceChangeType.or(AutoflowChangeType)
});
